var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHour(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.3334C5.40002 18.3334 1.66669 14.6084 1.66669 10.0001C1.66669 5.40008 5.40002 1.66675 10 1.66675C14.6084 1.66675 18.3334 5.40008 18.3334 10.0001C18.3334 14.6084 14.6084 18.3334 10 18.3334ZM12.6584 13.0917C12.7584 13.1501 12.8667 13.1834 12.9834 13.1834C13.1917 13.1834 13.4 13.0751 13.5167 12.8751C13.6917 12.5834 13.6 12.2001 13.3 12.0167L10.3334 10.2501V6.40008C10.3334 6.05008 10.05 5.77508 9.70835 5.77508C9.36669 5.77508 9.08335 6.05008 9.08335 6.40008V10.6084C9.08335 10.8251 9.20002 11.0251 9.39169 11.1417L12.6584 13.0917Z",
    fill: "#495E57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHour);
export default __webpack_public_path__ + "static/media/Hour.4eeb5db94c6d1867eec9c3115f6798ae.svg";
export { ForwardRef as ReactComponent };